import EmailErrorMessage from './EmailErrorMessage';

export default EmailErrorMessage;
